module.exports = __webpack_public_path__ + "img/logo.53e45259.png";